import { FormGroup } from '@angular/forms';
import { environment } from '../../environments/environment';
//import { IOauthResponse } from '../api/oauth/response/i-oauth.request';
//import { StrictHttpResponse } from '../api/customers/models/strict-http.response';
//import { SecurityProvider } from '../providers/security/security';
//import { OauthService } from '../api/oauth/service/oauth.service';
export class SharedFunctions {

    static getMinuteDifference(time1: string, time2: string) {
        const [hours1, minutes1, seconds1] = time1.split(':').map(Number);
        const [hours2, minutes2, seconds2] = time2.split(':').map(Number);
        var date1:any = new Date(0, 0, 0, hours1, minutes1, seconds1);
        var date2:any = new Date(0, 0, 0, hours2, minutes2, seconds2);
        var result: number = (date2 - date1);
        const differenceInMs = Math.abs(result);
        const differenceInMinutes = Math.floor(differenceInMs / (1000 * 60));
        return differenceInMinutes;
    }

    public fieldValidated(formG: FormGroup, field: string) {
        return formG.controls[field].errors && formG.controls[field].touched;
    }

    static formatDateToText(dateString: string | null): string {
      if (!dateString || isNaN(new Date(dateString).getTime())) {
        return "";
      }
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
      });
    }
    
}
